// removed by extract-text-webpack-plugin
module.exports = {"root":"Button__root__1Z5Y8","primaryButtonRoot":"Button__primaryButtonRoot__1HjV-","secondaryButtonRoot":"Button__secondaryButtonRoot__3vFqn","inlineTextButtonRoot":"Button__inlineTextButtonRoot__Ak94S","primaryButton":"Button__primaryButton__3Tp6d","secondaryButton":"Button__secondaryButton__1F_I5","inProgress":"Button__inProgress__2irFc","ready":"Button__ready__2cLni","spinner":"Button__spinner__ugCLU","checkmark":"Button__checkmark__nqrpn","checkmarkAnimation":"Button__checkmarkAnimation__2D1Lq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Button/Button.css
// module id = 1522
// module chunks = 0